import React from "react";
import Lottie from "lottie-react";
import loaderAnimation from "../../../assets/loader.json";
import { styled } from "../../../stitches.config";

const Overlay = styled("div", {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.8)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
});

const LoaderBox = styled("div", {
  width: 100,
  height: 100,
});

interface LoadingOverlayProps {
  children?: React.ReactNode;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ children }) => {
  return (
    <Overlay>
      <LoaderBox>
        <Lottie animationData={loaderAnimation} loop autoplay />
        {children}
      </LoaderBox>
    </Overlay>
  );
};
